export const IMPORT_SOURCES = [
  "AdvancedMD",
  "Aesthetic Record",
  "AestheticsPro",
  "Booker",
  "Boulevard",
  "ChiroFusion",
  "ChiroTouch",
  "Cliniko",
  "DrChrono",
  "Fresha",
  "GlossGenius",
  "Jane",
  "Mangomint",
  "Mindbody",
  "ModMed",
  "MyTime",
  "Nextech",
  "Pabau",
  "PatientNow",
  "QuickerNotes",
  "SimplePractice",
  "Symplast",
  "Tebra",
  "TouchMD",
  "Vagaro",
  "WellnessLiving",
  "Zenoti",
  "Other",
] as const;

export type ImportSource = (typeof IMPORT_SOURCES)[number];

export type DeliveryMethod = "pull" | "upload" | "skip";

export interface DataCategory {
  value: string;
  label: string;
  description: string;
}

export const CATEGORY_REVIEW_ROUTES: Record<
  string,
  (tenant: string) => string
> = {
  appointments: (t) => `/${t}/calendar`,
  billing: (t) => `/${t}/billing/charges`,
  providers: (t) => `/${t}/settings/users`,
  forms: (t) => `/${t}/check-in/forms/list`,
  memberships: (t) => `/${t}/memberships`,
  medications: (t) => `/${t}/settings/medications`,
  inventory: (t) => `/${t}/inventory`,
};

export const CATEGORY_REVIEW_CALLOUTS: Record<string, string> = {
  appointments:
    "Review your imported appointments in the calendar. Check that dates, providers, and services look correct.",
  billing:
    "Review outstanding balances and billing records. Verify amounts and patient associations.",
  providers:
    "Verify provider profiles, roles, and schedules are set up correctly.",
  forms: "Check that your intake and consent forms were imported properly.",
  memberships:
    "Review active memberships and packages. Verify pricing and patient assignments.",
  medications: "Check that medication records and prescriptions are accurate.",
  inventory: "Verify product stock levels and reorder settings.",
};

export const DATA_CATEGORIES: DataCategory[] = [
  {
    value: "patients",
    label: "Patients",
    description: "Patient demographics, contact info, and medical history",
  },
  {
    value: "appointments",
    label: "Appointments",
    description: "Past and upcoming appointment records",
  },
  {
    value: "documents",
    label: "Documents / Photos",
    description: "Patient documents, photos, and attachments",
  },
  {
    value: "services",
    label: "Services",
    description: "Service menu with pricing, duration, and categories",
  },
  {
    value: "products",
    label: "Products",
    description: "Retail products with pricing and inventory",
  },
  {
    value: "billing",
    label: "Billing / Balances",
    description: "Outstanding balances and billing history",
  },
  {
    value: "providers",
    label: "Providers",
    description: "Provider profiles and schedules",
  },
  {
    value: "locations",
    label: "Locations",
    description: "Clinic locations, addresses, and operating hours",
  },
  {
    value: "forms",
    label: "Forms",
    description: "Intake forms, consent forms, and templates",
  },
  {
    value: "memberships",
    label: "Memberships / Packages",
    description: "Active memberships, packages, and subscriptions",
  },
  {
    value: "medications",
    label: "Medications",
    description: "Medication records and prescriptions",
  },
  {
    value: "notes",
    label: "Clinical Notes",
    description: "Visit notes, SOAP notes, and progress notes",
  },
  {
    value: "inventory",
    label: "Inventory",
    description: "Product stock levels and reorder info",
  },
];
